import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Content from "../Modulos/Prossmap/Ranking/Content";

const ProssmapRanking = () => {
    return (
        <>
            <NavBar title="PROSSMAP — RANKING" goBackOnePage />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    );
};

export default ProssmapRanking;
